export default {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    'https://acceptance-api.scheduling-form.aws.healtherides.com/scheduling-form-api',
  locationSearch: 'location-autocomplete',
  locationDetails: 'location-details',
  tripEstimate: 'trip-estimate',
  tripRequest: 'trip-request',
};
